import _defineProperty from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/defineProperty";
import '@wds/styles';
import 'react';
import { createUseStyles } from 'react-jss';

/** Function that returns either white or black depending on which has higher contrast with the specified color */
function contrastColor(color) {
  if (!color) {
    return '#000';
  }
  var rgb = color.match(/\d+/g);
  if (!rgb) {
    return '#000';
  }
  var r = parseInt(rgb[0], 10);
  var g = parseInt(rgb[1], 10);
  var b = parseInt(rgb[2], 10);
  var yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? '#000' : '#fff';
}
var prefix = 'smq-';
var selectors = ["[class*='".concat(prefix, "']"), "[class*='".concat(prefix, "']::before"), "[class*='".concat(prefix, "']::after")];
createUseStyles(function (theme) {
  var fontFamily = theme.type.fontFamily;
  var resetStyles = {
    '-webkit-font-smoothing': 'antialiased',
    boxSizing: 'border-box',
    fontFamily: fontFamily.base,
    listStyle: 'none',
    margin: 0,
    padding: 0
  };
  return {
    '@global': _defineProperty({}, selectors.join(','), resetStyles)
  };
}, {
  // Ensure this gets added to as the first stylesheet
  // ref: https://github.com/cssinjs/jss/blob/master/packages/react-jss/src/utils/getSheetIndex.js#L3-L16
  index: (Number.MIN_SAFE_INTEGER || -1e9) - 1,
  name: 'smquestions-global-styles'
});
export { contrastColor as c };